import { isDeepEqual } from '@attain-apps/data-utils'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as models from '../../models'
import type { Collection } from '../collection'

/**
 * Emits a context change action every time the context observable emits a new
 * (distinct) value
 */
export const detectContextChange = store.effects.create(
  <TTypeParams extends models.TypeParams.Constraint>(
    feature: Collection<TTypeParams>['feature'],
    context$: rxjs.Observable<TTypeParams['context']> | undefined,
  ) =>
    context$?.pipe(
      rxjs.distinctUntilChanged((a, b) => isDeepEqual(a, b)),
      rxjs.map(context =>
        feature.actions.changeContext.from('Context Changed').create({
          context,
        }),
      ),
    ),
)
